export const officeProductName = 'Folio'
export const officeProductDescription = 'Your files, your team’s files, and the work you share. Documents, spreadsheets, and presentations, together in Folio.'
export const officeHomePath = '/'
export const officeLoginPath = '/login'
export const forgeOrigin = import.meta.env.VITE_FORGE_ORIGIN || 'https://forge.int10h.de'
export const folioOrigin = import.meta.env.VITE_FOLIO_ORIGIN || 'https://folio.int10h.de'

export default function OfficeBrand() {
  return <span className="folio-brand">
    <svg viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <path d="M9 5h16v22H9z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      <path d="M5 9v18a4 4 0 0 0 4 4h12M13 11h8M13 16h8M13 21h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
    <strong>{officeProductName}</strong>
  </span>
}
